import { PRIMARY, TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../utils/style';
import { identity } from '../../utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const KEY_PADDING = 4;

const BORDER_RADIUS = 4;

const BORDER_WIDTH = 3;

export const MAX_ITEMS_PER_ROW = 4;

export const colors = {
  scalableContent: makeThemeColor(TERTIARY),
  background: makeThemeColor(PRIMARY, 0.1),
  border: makeThemeColor(PRIMARY),
};

export const getInitialStyle = (context = defaultContext) => {
  const { colorMode } = context;

  return {
    visible: false,
    ScalableContent: {
      rect: true,
      w: 0,
      h: 0,
      color: colors.scalableContent[colorMode],
      Background: {
        rect: true,
        w: identity,
        h: identity,
        color: colors.background[colorMode],
        shader: {
          strokeColor: colors.border[colorMode],
          stroke: BORDER_WIDTH,
          radius: BORDER_RADIUS,
        },
      },
      Keys: {
        x: KEY_PADDING,
        y: KEY_PADDING,
      },
    },
  };
};
